import Vue from 'vue'
import Vuex from 'vuex'
import Common from './api/common'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		User: {},
		userName: '',
		currentAccountSets: {},
		myAccountSets: [],
		sliderCollapsed: false,
		Menus: [],
		fun: {memberUpdate: false, memberPay: false},
	},
	mutations: {
		updateAccount(state, data) {
			state.User = data;
			state.userName = data.name;
			state.Menus = data.menus;
		},
		updateSliderCollapse(state, isShow) {
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			state.sliderCollapsed = isShow;
		}
	},
	actions: {
		init(context) {
			return new Promise((resolve, reject) => {
				Common.init().then(({data}) => {
					context.commit('updateAccount', data);
					resolve(data)
				}).catch(() => {
					reject();
				})
			});
		}
	},
	getters: {
		account: state => {
			return state.User;
		},
		sliderCollapsed: state => {
			return state.sliderCollapsed;
		},
		Menus: state => {
			return state.User.menus;
		},
		fun: state => {
			return state.fun;
		},
	}
})
